module.exports = __webpack_public_path__ + "img/car-green.6bfc81b5.svg";